<template>
  <div
    ref='root'
    v-show='visible'
    class='popup login'
  >
    <div class="content" ref="content">
      <div class="mb-2">{{ $t('加工依頼へ進むにはEMARFアカウントのログインが必要です。') }}</div>
      <div class="mb-1">
        <input
          v-model="email"
          type="text"
          :placeholder="$t('メールアドレス')"
        />
      </div>
      <div class="mb-2">
        <input
          v-model="password"
          type="password"
          :placeholder="$t('パスワード')"
        />
      </div>
      <div class="mb-2">
        <button @click="onSubmit">{{ $t('ログイン') }}</button>
      </div>
      <div class="detail-text">
        <p class="mb-1">{{ $t('パスワードをお忘れの方は') }}<a :href="forgetPassURL" target="_blank">{{ $t('こちら') }}</a></p>
        <p>{{ $t('アカウント作成は') }}<a :href="signupURL" target="_blank">{{ $t('こちら') }}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import PopupBase from './PopupBase.vue';

export default {
  name: 'LoginPopup',
  extends: PopupBase,

  data () {
    return {
      email: "",
      password: "",
      signupURL: "/register",
      forgetPassURL: "/forgotpassword",
    };
  },

  mounted () {
    document.addEventListener('click', (e) => {
      if (this.visible) {
        // hide if a user clicks on the outside of a form
        const path = this.getPath(e);
        if (!path.includes(this.$refs.content)) {
          this.hide();
        }
      }
    });
  },

  methods: {
    onSubmit () {
      Auth.signIn(this.email, this.password).then(() => {
        this.hide();
        this.$emit('authenticated');
      }).catch(error => {
        alert(error.message);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login{
  .content{
    width: 450px;
    height: 300px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .mb-1 {
      margin-bottom: .5rem;
    }
    .mb-2 {
      margin-bottom: 2rem;
    }

    input{
      border-style: solid;
      border-radius: 6px;
      padding: 5px 8px;
    }

    button{
      background-color: #1bffc6;
      width: 110px;
      height: 36px;
      border-radius: 99em;
      border: none;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
    }

    .detail-text{
      text-align: center;

      a{
        color: #000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPopup.vue